/**
 * @return {null | string}
 */
module.exports = function getBrowserQueryString() {
    const queryString = window.location.search;

    if (queryString) {
        return queryString;
    }

    return null;
}
